import { Alert } from "../../../../core/Alert.js";
import { Button } from "../../../../core/Button.js";
import { DescriptionList } from "../../../../core/DescriptionList.js";
import { Input } from "../../../../core/Input.js";
import { FairnessCard } from "../../card/FairnessCard.js";
import type { FairnessSeedContent } from "../../fairnessContent.js";

/**
 * One UTC day's server seed: pick the day, then its hash commitment and, once the day is over,
 * the seed itself.
 */
export function FairnessSeed({
  title,
  description,
  date,
  submit,
  onSubmit,
  error,
  facts,
}: FairnessSeedContent) {
  return (
    <FairnessCard title={title} description={description}>
      <form
        className="flex flex-col gap-3 sm:flex-row sm:items-end"
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
      >
        <Input
          label={date.label}
          type="date"
          required
          max={date.max}
          value={date.value}
          onChange={(event) => {
            // A cleared date picker reports ""; keep the last day rather than look up nothing.
            if (event.target.value) date.onChange(event.target.value);
          }}
          mono
          className="min-w-0 flex-1"
        />
        <Button
          type="submit"
          loading={submit.busy}
          disabled={submit.disabled}
          className="max-sm:w-full"
        >
          {submit.busy ? submit.busyLabel : submit.label}
        </Button>
      </form>
      {error && <Alert tone="danger">{error}</Alert>}
      {facts && <DescriptionList items={facts} />}
    </FairnessCard>
  );
}
